// The flag SVGs, keyed by the API's country code (`de` -> .../de.svg).
const urls = import.meta.glob<string>('/src/assets/flags/*.svg', {
  eager: true,
  query: '?url',
  import: 'default',
})

export const flagUrl = (code: string): string | undefined =>
  urls[`/src/assets/flags/${code.toLowerCase()}.svg`]
